<template>
  <div
    ref="convstooltip"
    class="con-vs-tooltip"
    @mouseleave="mouseleavex"
    @mouseenter="mouseenterx"
    @mouseup="destroy"
  >
    <transition name="tooltip-fade">
      <div
        v-show="active"
        ref="vstooltip"
        :class="[
          `vs-tooltip-${positionx || position}`,
          `vs-tooltip-${color}`,
          { 'after-none': noneAfter },
        ]"
        :style="style"
        class="vs-tooltip with-text"
      >
        <h4 v-if="title">{{ title }}</h4>
        <slot name="text"></slot>
      </div>
    </transition>
    <slot name="inner"></slot>
  </div>
</template>
<script>
import VxTooltip from "./VxTooltip";
import Vue from "vue";

const Base = Vue.extend(VxTooltip);
export default Base.extend({
  name: "vx-tooltip-slot-text",
});
</script>
